import { ErrorMessageMapper } from '@app/hooks/useOpenErrorModal';

export const PLAN_OLD_MONTH = '09bd3ec0-1719-11ea-b06f-8f92400fbb0b';
export const PLAN_OLD_YEAR = 'f54db8e0-2224-11ea-a800-0f780c68282d';
export const PLAN_TRIAL = '38446ca0-0783-11ea-af5f-8b385e2d6c08';

// todo: 아래의 요금제 관련하여 하드코딩 되어있는 부분 수정 필요
/** @deprecated */
export const PLAN_MONTH_STARTER = '71682a30-5927-11ea-9a09-95823f696e02';
/** @deprecated */
export const PLAN_MONTH_BUSINESS = '5d5d3e90-5927-11ea-9a09-95823f696e02';
/** @deprecated */
export const PLAN_MONTH_PREMIUM = 'c3928710-66e4-11ed-9e98-697e3ed68992';

/** @deprecated */
export const PLAN_YEAR_STARTER = '524bfdc0-e342-11ea-9b0f-a12ce7b81cb4';
/** @deprecated */
export const PLAN_YEAR_BUSINESS = '09da0dd0-85ba-11ed-b0ad-dd467456cbee';
/** @deprecated */
export const PLAN_YEAR_PREMIUM = '0579e800-85ba-11ed-b0ad-dd467456cbee';

export const PLAN_STARTER_PRICE = 9900;
export const PLAN_BUSINESS_PRICE = 39900;
export const PLAN_PREMIUM_PRICE = 74900;
export const PLAN_STARTER_DISCOUNTED_MONTH_PRICE = 9900;
export const PLAN_BUSINESS_DISCOUNTED_MONTH_PRICE = 39900;
export const PLAN_PREMIUM_DISCOUNTED_MONTH_PRICE = 74900;
export const PLAN_STARTER_DISCOUNTED_YEAR_PRICE = 7900;
export const PLAN_BUSINESS_DISCOUNTED_YEAR_PRICE = 24900;
export const PLAN_PREMIUM_DISCOUNTED_YEAR_PRICE = 39900;

export const PAYMENT_ERROR_MESSAGE_MAPPER: ErrorMessageMapper = {
  'User not found': '사용자 정보가 없습니다.',
  'Plan not found': '요금제를 찾을 수 없습니다.',
  'Member user cannot create subscription':
    '멤버는 요금제를 구매할 수 없습니다.\n구매가 필요한 경우, 워크스페이스 관리자에게 문의해 주세요.'.split(
      '\n'
    ),
  'Not enough seat quantity':
    '이용 중인 추가 인원의 수가 선택한 요금제에서 제공하는 추가 인원수보다 많습니다.',
  'Not enough template quantity':
    '이용 중인 템플릿 개수가 선택한 요금제에서 제공하는 템플릿 개수보다 많습니다.',
  'Plan does not contain organization':
    '선택한 요금제에 워크스페이스 기능이 없습니다. 워크스페이스 기능이 포함된 요금제를 선택해 주세요.',
  'Plan does not contain template':
    '선택한 요금제에 템플릿 기능이 없습니다. 템플릿 기능이 포함된 요금제를 선택해 주세요.',
  'Forbidden to purchase plan':
    '요금제를 구매할 수 없습니다.\n구매가 필요한 경우 고객센터에 문의해 주세요.'.split('\n'),
  'Subscription already exist': '이미 이용 중인 요금제가 있습니다.',
  'Add feature usage is exist':
    '사용량을 충전한 달에는 요금제 변경이 제한됩니다.\n요금제 변경이 필요할 시 고객센터로 문의해주세요.'.split(
      '\n'
    ),
  'Cannot change subscription':
    '요금제를 변경할 수 없습니다.\n요금제 변경이 필요할 시 고객센터로 문의해주세요.'.split('\n'),
};
